export default (array, element, index) => [
  ...array.slice(0, index),
  element,
  ...array.slice(index),
]
